import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {AdminEntityService} from "./AdminEntityService";
import {
    LoginNotification
} from "../../../generated/protocol";
import {injectable} from "inversify";

export interface NotificationService extends AdminEntityService<void> {
    getActiveNotifications(): Promise<LoginNotification[]>;
}

@injectable()
export class NotificationServiceImpl extends AbstractAdminEntityService<void, LoginNotification[]> {

    constructor() {
        super("/notification");
    }

    getActiveNotifications(): Promise<{}> {
        return this.http.doGet(this.entityPath);
    }
}



// WEBPACK FOOTER //
// ./src/app/service/admin/NotificationService.ts